export const locations = {
  AM: 'Athis-Mons',
  CE: 'Corbeil-Essonnes'
}